import { useEffect, useState } from "react";

const OPENING = new Date("2026-12-01T00:00:00-05:00").getTime();

const remaining = () => {
  const ms = Math.max(0, OPENING - Date.now());
  return {
    days: Math.floor(ms / 86400000),
    hours: Math.floor((ms / 3600000) % 24),
    minutes: Math.floor((ms / 60000) % 60),
    seconds: Math.floor((ms / 1000) % 60),
    done: ms === 0,
  };
};

export const OpeningCountdown = () => {
  const [t, setT] = useState(remaining);
  useEffect(() => {
    const id = setInterval(() => setT(remaining()), 1000);
    return () => clearInterval(id);
  }, []);

  if (t.done) {
    return <p className="font-display text-2xl font-bold text-[#F5B90A]" data-testid="opening-countdown-done">Our doors are open!</p>;
  }

  return (
    <div className="flex gap-3" data-testid="opening-countdown">
      {["days", "hours", "minutes", "seconds"].map((k) => (
        <div key={k} className="min-w-[72px] rounded-lg border border-[#F5B90A]/40 bg-white/5 px-3 py-3 text-center backdrop-blur-sm">
          <p className="font-display text-3xl md:text-4xl font-bold tabular-nums" data-testid={`countdown-${k}`}>{String(t[k]).padStart(2, "0")}</p>
          <p className="mt-1 text-[10px] uppercase tracking-[0.2em] text-white/60">{k}</p>
        </div>
      ))}
    </div>
  );
};
